<template>
  <v-chip
    v-if="label"
    small
    class="font-weight-bold overline"
    :color="color"
    :text-color="textColor"
  >
    <v-icon left x-small>mdi-checkbox-blank-circle</v-icon>
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  props: {
    value: { type: String, required: true },
  },
  computed: {
    label() {
      return (
        {
          ACTIVE: "Aktivní",
          PAUSED: "Zastavená",
          REJECTED: "Zamítnutá",
          DRAFT: "Rozepsaná",
        }[this.value] ?? null
      )
    },
    color() {
      return (
        {
          ACTIVE: "green lighten-4",
          PAUSED: "red lighten-4",
          REJECTED: "red lighten-4",
          DRAFT: "navy lighten-3",
        }[this.value] ?? null
      )
    },
    textColor() {
      return (
        {
          ACTIVE: "green",
          PAUSED: "red",
          REJECTED: "red",
          DRAFT: "navy",
        }[this.value] ?? null
      )
    },
  },
}
</script>
